import { connect } from 'react-redux';

import { isRtl } from 'modules/language/selectors/language';
import ModalsPlace from './ModalsPlace';
import { currentModal } from '../../selectors';

function mapStateToProps(state) {
  const modal = currentModal(state);

  return {
    ...modal,
    modalShown: !!state.messageSystem.modals.currentModal,
    rtl: isRtl(),
  };
}

export default connect(
  mapStateToProps,
)(ModalsPlace);
